// import React from 'react';
// import { TextField, InputAdornment, Typography } from '@mui/material';
// import ErrorIcon from '@mui/icons-material/Error';
// import palette from 'src/theme/palette';

// const InputField = ({
//   label,
//   name,
//   type = 'text',
//   value,
//   onChange,
//   onBlur,
//   error,
//   helperText,
//   placeholder,
//   autoComplete,
//   styleMainContainer,
//   backgroundColor,
//   disabled,
//   fontFamily,
//   marginBottom,
//   height,
//   fontSize,
//   color,
//   labelColor,
//   width,
//   labelFontMedium
// }) => {
//   return (
//     <div
//       style={{
//         ...styleMainContainer,
//         marginBottom: error ? '0.2rem' : marginBottom || '1rem'
//       }}
//     >
//       {/* Top Label */}
//       {label && (
//         <Typography
//           sx={{
//             fontSize: 12,
//             marginBottom: '4px',
//             fontFamily: labelFontMedium ? 'poppinsMedium' : 'poppinsRegular',
//             color: labelColor ? labelColor : palette.primary.titledark
//           }}
//         >
//           {label}
//         </Typography>
//       )}

//       <TextField
//         disabled={disabled}
//         fullWidth
//         type={type}
//         name={name}
//         value={value}
//         onChange={onChange}
//         onBlur={onBlur}
//         error={Boolean(error)}
//         helperText={error ? helperText : ''}
//         FormHelperTextProps={{
//           sx: {
//             fontFamily: 'poppinsRegular',
//             fontSize: 11,
//             marginLeft: '0px',
//             marginTop: '4px',
//             color: '#7F1D1D' // MUI default error color
//           }
//         }}
//         placeholder={placeholder}
//         autoComplete={autoComplete}
//         variant="outlined"
//         InputProps={{
//           endAdornment: error && (
//             <InputAdornment position="end">
//               <ErrorIcon color="error" sx={{ fontSize: 20 }} />
//             </InputAdornment>
//           ),
//           sx: {
//             height: 30,
//             fontSize: 12,
//             color: palette.primary.titledark
//           }
//         }}
//         onKeyDown={(e) => {
//           if (type === 'number') {
//             if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
//               e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
//             }
//           }
//         }}
//         sx={{
//           '& .MuiOutlinedInput-root': {
//             borderRadius: '6px',
//             fontFamily: fontFamily ? fontFamily : 'poppinsRegular',
//             fontSize: fontSize ? fontSize : 12,
//             color: color ? color : palette.primary.titledark,
//             height: height ? height : 40,
//             borderWidth: 1.5,
//             width: width,
//             // margin: margin,
//             backgroundColor: backgroundColor ? backgroundColor : 'transparent',
//             '& input:-webkit-autofill': {
//               boxShadow: '0 0 0 1000px #fff inset !important',
//               WebkitTextFillColor: palette.primary.titledark,
//               transition: 'background-color 5000s ease-in-out 0s'
//             },
//             '& fieldset': {
//               borderColor: error ? palette.primary.inputbordererror : palette.primary.inputborder,
//               borderWidth: '1.5px'
//             },
//             '&:hover fieldset': {
//               borderColor: error ? palette.primary.inputbordererror : palette.primary.inputborder
//             },
//             '&.Mui-focused fieldset': {
//               borderColor: error ? palette.primary.inputbordererror : palette.primary.inputborder,
//               borderWidth: '1.5px'
//             }
//           }
//         }}
//       />
//     </div>
//   );
// };

// export default InputField;

import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton, Typography, Box } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import palette from 'src/theme/palette';

const InputField = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  onBlur,
  error,
  helperText,
  placeholder,
  autoComplete,
  styleMainContainer,
  backgroundColor,
  disabled,
  fontFamily,
  marginBottom,
  height,
  fontSize,
  color,
  labelColor,
  width,
  labelFontMedium,
  label2,
  qty
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === 'password';

  return (
    <div
      style={{
        ...styleMainContainer,
        marginBottom: error ? '0.2rem' : marginBottom || '1rem'
      }}
    >
      {/* Top Label */}
      {label && (
        <Typography
          sx={{
            fontSize: 12,
            marginBottom: '4px',
            fontFamily: labelFontMedium ? 'poppinsMedium' : 'poppinsRegular',
            color: labelColor ? labelColor : palette.primary.titledark
          }}
        >
          {label}
        </Typography>
      )}

      {label2 && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
          <Typography
            sx={{
              fontSize: 12,
              marginBottom: '4px',
              fontFamily: labelFontMedium ? 'poppinsMedium' : 'poppinsRegular',
              color: labelColor ? labelColor : palette.primary.titledark,
              mr: 0.5
            }}
          >
            {label2} {`(${qty})`}
          </Typography>
          <Typography
            sx={{
              fontSize: 12,
              marginBottom: '4px',
              fontFamily: 'poppinsSemiBold',
              color: 'red'
            }}
          >
            Field Technician - Field Verify QTY and submit Actual HERE
          </Typography>
        </Box>
      )}

      <TextField
        disabled={disabled}
        fullWidth
        type={isPassword && showPassword ? 'text' : type}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={Boolean(error)}
        helperText={error ? helperText : ''}
        FormHelperTextProps={{
          sx: {
            fontFamily: 'poppinsRegular',
            fontSize: 11,
            marginLeft: '0px',
            marginTop: '4px',
            color: '#7F1D1D'
          }
        }}
        placeholder={placeholder}
        autoComplete={autoComplete}
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {error && <ErrorIcon color="error" sx={{ fontSize: 20, mr: 0.5 }} />}
              {isPassword && (
                <IconButton
                  size="small"
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                >
                  {showPassword ? (
                    <VisibilityOff fontSize="small" />
                  ) : (
                    <Visibility fontSize="small" />
                  )}
                </IconButton>
              )}
            </InputAdornment>
          ),
          sx: {
            height: 30,
            fontSize: 12,
            color: palette.primary.titledark
          }
        }}
        onKeyDown={(e) => {
          if (type === 'number') {
            if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
              e.preventDefault();
            }
          }
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
            fontFamily: fontFamily ? fontFamily : 'poppinsRegular',
            fontSize: fontSize ? fontSize : 12,
            color: color ? color : palette.primary.titledark,
            height: height ? height : 40,
            width: width,
            backgroundColor: backgroundColor ? backgroundColor : 'transparent',
            '& input:-webkit-autofill': {
              boxShadow: '0 0 0 1000px #fff inset !important',
              WebkitTextFillColor: palette.primary.titledark,
              transition: 'background-color 5000s ease-in-out 0s'
            },
            '& fieldset': {
              borderColor: error ? palette.primary.inputbordererror : palette.primary.inputborder,
              borderWidth: '1.5px'
            },
            '&:hover fieldset': {
              borderColor: error ? palette.primary.inputbordererror : palette.primary.inputborder
            },
            '&.Mui-focused fieldset': {
              borderColor: error ? palette.primary.inputbordererror : palette.primary.inputborder,
              borderWidth: '1.5px'
            }
          }
        }}
      />
    </div>
  );
};

export default InputField;
